import React from 'react';

const AppFooter = (props) => {
    return <div >footer goes here </div> 
}

export default AppFooter ;
